import FormConfig from "./formConfig.js";
import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      options: [],
      tenderProjectClassifyNames: [],
      tenderProjectClassifyCodes: [],
      // 表格基础数据
      tableColumns: [
        {
          label: "标段号",
          prop: "section",
          width: "80",
          fixed: true,
        },
        {
          label: "描述",
          prop: "description",
          width: "350",
        },
        {
          label: "标段（包）招标次数",
          prop: "bidSectionNum",
          width: "350",
        },
        {
          label: "合同估算价（万元）",
          prop: "contractReckonPrice",
          width: "180",
        },
        // {
        //   label: "合同估算价币种",
        //   prop: "currencyName",
        //   width: "140",
        // },
        // {
        //   label: "合同估算价单位",
        //   slotName: "priceUnitName",
        //   width: "140",
        // },
        {
          label: "（包）分类",
          prop: "tenderProjectClassifyName",
          width: "200",
        },
        {
          label: "投标有效期（日历天）",
          prop: "tenderValidityDay",
          width: "200",
        },
        {
          label: "是否远程评标",
          slotName: "isRemoteEvaluating",
          width: "150",
        },
        {
          label: "不远程评标原因",
          prop: "noRemoteReason",
          width: "300",
        },
        {
          label: "是否十大工程项目",
          slotName: "isSdgc",
          width: "150",
        },
        {
          label: "是否政府投资项目",
          slotName: "isGovernmentInvestment",
          width: "150",
        },
        {
          label: "是否使用财政性资金",
          slotName: "isFinancialCapital",
          width: "170",
        },
        {
          label: "（包）所在行政区域",
          prop: "sectionAreaCodeName",
          width: "200",
        },
        {
          label: "交易发生行政区域",
          prop: "dealAreaCodeName",
          width: "200",
        },
        {
          label: "采购计划备案号",
          prop: "cgjhbaCode",
          width: "200",
        },
      ],
      // 表单对象
      form: {
        section: null, // 标段号
        description: null, // 标段描述
        bidSectionNum: null, // 标段（包）招标次数
        contractReckonPrice: null, // 标段合同估算价
        currencyName: null, // 标段合同估算价币种
        currencyCode: null, // 标段合同估算价币种代码
        priceUnitName: null, // 标段合同估算价单位
        priceUnit: null, // 标段合同估算价单位
        tenderProjectClassifyName: null, // 标段（包）分类
        tenderProjectClassifyCode: null, // 标段（包）分类代码
        tenderProjectClassifyCodeSelect: null, // 标段（包）分类代码下拉框数据
        tenderValidityDay: null, // 投标有效期（日历天）
        isRemoteEvaluating: '0', // 是否远程评标标段
        noRemoteReason: "“省、武汉市、武汉市远城区交易（采购）中心使用省综合评标（评审）专家库武汉区域库，专家资源比较充足，原则上不作为主场开展政府投资项目省内远程异地评标”。", // 不远程评标原因
        isSdgc: null, // 是否十大工程项目
        isGovernmentInvestment: null, // 是否政府投资项目
        isFinancialCapital: null, // 是否使用财政性资金
        sectionAreaCode: null, // 标段（包）所在行政区域代码
        sectionAreaCodeName: null, // 标段（包）所在行政区域
        dealAreaCodeName: null, // 交易发生行政区域
        dealAreaCode: null, // 交易发生行政区域代码
        cgjhbaCode: null, // 采购计划备案号
      },
      // 表单错误
      errRules: {
        section: null, // 标段号
        description: null, // 标段描述
        bidSectionNum: null, // 标段（包）招标次数
        contractReckonPrice: null, // 标段合同估算价
        currencyName: null, // 标段合同估算价币种
        currencyCode: null, // 标段合同估算价币种代码
        priceUnitName: null, // 标段合同估算价单位
        priceUnit: null, // 标段合同估算价单位
        tenderProjectClassifyName: null, // 标段（包）分类
        tenderProjectClassifyCode: null, // 标段（包）分类代码
        tenderProjectClassifyCodeSelect: null, // 标段（包）分类代码下拉框数据
        tenderValidityDay: null, // 投标有效期（日历天）
        isRemoteEvaluating: null, // 是否远程评标标段
        noRemoteReason: null, // 不远程评标原因
        isSdgc: null, // 是否十大工程项目
        isGovernmentInvestment: null, // 是否政府投资项目
        isFinancialCapital: null, // 是否使用财政性资金
        sectionAreaCode: null, // 标段（包）所在行政区域代码
        sectionAreaCodeName: null, // 标段（包）所在行政区域
        dealAreaCodeName: null, // 交易发生行政区域
        dealAreaCode: null, // 交易发生行政区域代码
        cgjhbaCode: null, // 采购计划备案号
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 操作类型
      controllerFlg: null,// 操作标志
      // 主键
      id: null, // 主键
      // 表格数据
      tableData: [],
      // 表头按钮组
      btnList: [
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        },
      ],
      mineStatusValue: null, // el-option的value
      // tree数据默认参数和后台给的参数对应
      defaultProps: {
        children: "children", // 子节点名称
        label: "professionName" // 节点名称
      },
      tenderProjectClassifyName: null, // 标段（包）分类名称
      // 勾选的数据
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {

  },
  // 自定义方法
  methods: {
    /**
     * details页面初始化后开始加载各子页面方法
     */
    fun_Open(){
      // 如果是详情
      if (this.controllerFlg === 'detail') {
        // 清空表头
        this.btnList = [];
        // 重新设置表单
        this.formConfigList[0].formConfigList = [
          {
            label: "",
            type: "slot",
            class: "formList",
            width: "100%;",
            slotName: "listPrjDetail",
            value: "listPrjDetail",
          }
        ]
      }
      // 获取标段信息
      this.fun_GetList();
      // 获取标段包分类
      this.fun_TenderProjectClassifyCodeSelect();
    },

    /**
     * 下拉框change事件
     * @params e 选择的值
     * @author 滕威
     */
    fun_GetSelectVal(e, i, options) {          
      // 标段合同估算价币种代码
      if (i === "currencyCode") {
        // 标段合同估算价币种代码
        this.form.currencyCode = e;
        // 循环下拉框
        options.forEach(value => {
          // 匹配
          if (value.value === e) {
            // 标段合同估算价币种代码名称
            this.form.currencyName = value.name;
          }
        });
        // 标段合同估算价单位
      }else if (i === "priceUnit") {
        // 标段合同估算价单位
        this.form.priceUnit = e;
        // 循环下拉框
        options.forEach(value => {
          // 匹配
          if (value.value === e) {
            // 标段合同估算价单位名称
            this.form.priceUnitName = value.name;
          }
        });    
        // 标段（包）所在行政区域代码
      }else if (i === "sectionAreaCode") {
        // 标段（包）所在行政区域代码
        this.form.sectionAreaCode = e;
        // 循环下拉框
        options.forEach(value => {
          // 匹配
          if (value.value === e) {
            // 标段（包）所在行政区域代码
            this.form.sectionAreaCodeName = value.name;
          }
        });
        // 交易发生行政区域
      }else if (i === "dealAreaCode") {
        // 交易发生行政区域
        this.form.dealAreaCode = e;
        // 循环下拉框
        options.forEach(value => {
          // 匹配
          if (value.value === e) {
            // 交易发生行政区域
            this.form.dealAreaCodeName = value.name;
          }
        });
      }
      else{
        // 赋值
        this.form[i] = e;
      }
    },
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        fun_PostAction("/tenderRegistration/tenderPrjDetailList", {
          registrationId : this.id,
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 关闭loading
            this.loading = false;
            // 回显table
            this.tableData = data;
          } else {
            // 关闭loading
            this.loading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
    * 列表勾选事件
    * @author shuhua
    */
    fun_HandleSelectionChange(e) {
      // 赋值勾选数组
      this.multipleSelection = e;
    },
    /**
     * 标段 添加行
     * @param e
     */
    fun_Add(){
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 标段合同估算价存在的场合
          if (this.form.contractReckonPrice > 0) {
            // 标段合同估算价币种为空的场合
            // if (this.form.currencyCode == '') {
            //   // 错误提示
            //   this.errRules.currencyCode = "标段合同估算价大于零的场合，请输入“标段合同估算价币种”！";
            //   this.$message.error("标段合同估算价大于零的场合，请输入“标段合同估算价币种”！");
            //   return false;
            // }
            // // 标段合同估算价单位为空的场合
            // if (this.form.priceUnit == '') {
            //   // 错误提示
            //   this.errRules.priceUnit = "标段合同估算价大于零的场合，请输入“标段合同估算价单位”！";
            //   this.$message.error("标段合同估算价大于零的场合，请输入“标段合同估算价单位”！");
            //   return false;
            // }       
          } else {
             // 错误提示
             this.errRules.contractReckonPrice = "请输入“标段合同估算价”（估算价须高于0元）！";
             this.$message.error("请输入“标段合同估算价”（估算价须高于0元）！");
             return false;
          }
          // 标段（包）分类不存在的场合
          if (this.form.tenderProjectClassifyCode == '' || this.form.tenderProjectClassifyCode == '...') {
            // 错误提示
            this.errRules.tenderProjectClassifyCode = "请选择标段（包）分类！";
            this.$message.error("请选择标段（包）分类！");
            return false;
          }
          // 标段（包）分类存在的场合
          else {
            // 转为数组
            let code = this.form.tenderProjectClassifyCode.split(",");
            // 如果选择的分类数量大于3
            if (code.length > 3) {
              this.errRules.tenderProjectClassifyCodeSelect = null;
              // 错误提示
              this.$nextTick(() => {
                this.errRules.tenderProjectClassifyCodeSelect = "标段（包）分类不能大于3个！";
              })
              return false;
            }
          }
          // 错误消息
          let cnt = 0;
          // 遍历
          this.tableData.map((v, i) => {
            // 匹配标段编号是否一致
            if (this.form.section === parseInt(v.section)) {
              cnt++;
            }
          });
          // 如果标段号一致时
          if(cnt > 0){
            // 错误提示
            this.errRules.section = "输入的标段号重复，请重新输入！";
            return false;
          }
          // 标段合同估算价标志
          let contractReckonPriceFlag = "";
          // 如果标段合同估算价小于20000或者大于10亿  
          if ((this.form.contractReckonPrice*10000) < 20000 || (this.form.contractReckonPrice*10000) > 1000000000 ) {
            // 返回消息提示
            contractReckonPriceFlag = "标段合同估算价低于20000元或者高于10亿！";
          }
          // 如果消息不为空
          if(contractReckonPriceFlag){
            // 弹出询问confirm
            this.$confirm(contractReckonPriceFlag + "是否确定添加标段信息？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              // 设置表单
              let formTab = this.form;
              // 添加表单
              this.tableData = [...this.tableData, {
                ...formTab
              }];
              // 遍历错误消息
              for (let i in this.form) {
                // 如果是是否远程评标标段
                if (i == 'isRemoteEvaluating') {
                  // 赋值
                  this.form[i] = "0";
                }
                // 如果是不远程评标原因
                else if (i == 'noRemoteReason') {
                  // 赋值
                  this.form[i] = "“省、武汉市、武汉市远城区交易（采购）中心使用省综合评标（评审）专家库武汉区域库，专家资源比较充足，原则上不作为主场开展政府投资项目省内远程异地评标”。";
                } else {
                  // 设置为空
                  this.form[i] = null;
                }
              }
              // 清除验证
              this.$refs.collapseForm.$refs.enInform.resetFields()
            });
          }
          // 如果消息为空
          else{
            // 设置表单
            let formTab = this.form;
            // 添加表单
            this.tableData = [...this.tableData, {
              ...formTab
            }];
            // 遍历错误消息
            for (let i in this.form) {
              // 如果是是否远程评标标段
              if (i == 'isRemoteEvaluating') {
                // 赋值
                this.form[i] = "0";
              }
              // 如果是不远程评标原因
              else if (i == 'noRemoteReason') {
                // 赋值
                this.form[i] = "“省、武汉市、武汉市远城区交易（采购）中心使用省综合评标（评审）专家库武汉区域库，专家资源比较充足，原则上不作为主场开展政府投资项目省内远程异地评标”。";
              } else {
                // 设置为空
                this.form[i] = null;
              }
            }
            // 清除验证
            this.$refs.collapseForm.$refs.enInform.resetFields()
          }
        }else{
          // 提示信息
          this.$alert("输入内容存在错误，请根据提示完善内容！", "warning");
          return;
        }
      })
    },
    /**
    * 标段 删除行
    * @param e
    */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection.length <= 0) {
        // 提示信息
        this.$alert("最少选择一条数据！", "warning");
        return;
      }
      // 弹出询问confirm
      this.$confirm("是否确定删除选中数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 遍历
        this.multipleSelection.map((value, index) => {
          // 遍历
          this.tableData.map((v, i) => {
            // 匹配已选中的
            if (value.section === v.section) {
              // 删除勾选的数据
              this.tableData.splice(i, 1);
            }
          });
        });
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_Click(e) {
      switch (e) {
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 获取标段（包）分类下拉框
     */
    async fun_TenderProjectClassifyCodeSelect() {
      // 请求，获取结果集
      let res = await fun_PostAction("/professionalDivision/list?flag=1");
      // 解构res.data
      const { result, data, msg } = res.data;
      // 操作成功
      if (result) {
        // 赋值下拉框
        this.options = data;
      } else {
        // 请求失败，提示错误信息
        this.$message.error(msg);
      }
    },
    /**
     * 下拉框清除选项
     */
    fun_Clear() {
      // 清除所属机构选中的父级主键
      this.form.tenderProjectClassifyCode = null;
      // 清空所属机构名称
      this.tenderProjectClassifyName = null;
    },
    /**
     * 下拉框改变
     */
    fun_Change(e) {
      this.$nextTick(() => {
        // 标段包分类名称
        this.tenderProjectClassifyNames = [];
        // 标段包分类代码
        this.tenderProjectClassifyCodes = [];
        // 获取选中节点
        const nodes = this.$refs.tenderProjectClassifyCodeSelect.getCheckedNodes();
        // 如果选中了值
        if (nodes.length > 0) {
          // 遍历选中节点
          nodes.forEach(e => {
            // 将拼接好的节点存入数组
            this.tenderProjectClassifyNames.push(e.label);
            // 将拼接好的节点存入数组
            this.tenderProjectClassifyCodes.push(e.value);
          });
          // 将选中的所有节点用逗号拼接
          this.form.tenderProjectClassifyName = this.tenderProjectClassifyNames.join(",");
          // 将选中的所有节点用逗号拼接
          this.form.tenderProjectClassifyCode = this.tenderProjectClassifyCodes.join(",");
        }
      })
    }
  }
};
